import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const ConfirmSubmit = ({isOpen, onCancel, onConfirm, message}) => {
    return ( 
        <div>
        <Modal isOpen={isOpen} toggle={onCancel} >
          <ModalHeader color="info">Confirmation</ModalHeader>
          <ModalBody>
             {message}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={onConfirm}>Confirm</Button>{' '}
            <Button color="secondary" onClick={onCancel}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
     );
}
 
export default ConfirmSubmit;